/**
 * @file partial-deliver-span.tsx
 * @module app/modules/_common/components/partial-deliver-span
 * @description Reusable component to display partial delivery status icon with tooltip.
 * Renders a partial delivery indicator when order is partially delivered
 * (total quantities > processed quantities && processed quantities > 0).
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.3.0
 * @version 2.1.2
 */

import { OverlayTrigger, Popover } from 'react-bootstrap';
import { IMAGES } from '../../../../utils/assetsAndPermissions';
import { isPartiallyProcessedOrder } from '../../orders-delivery/utils/quantity';

interface PartialDeliverSpanProps {
  orderVal: any;
  className?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

export const PartialDeliverSpan: React.FC<PartialDeliverSpanProps> = ({
  orderVal,
  className = 'me-2',
  placement = 'top',
}) => {
  const isPartialDelivery = isPartiallyProcessedOrder(orderVal);

  if (!isPartialDelivery) {
    return null;
  }

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement={placement}
      overlay={
        <Popover className="bg-dark">
          <Popover.Body className="text-white fw-500 py-2 px-3">
            Partial Delivery
          </Popover.Body>
        </Popover>
      }
    >
      <img
        className={`${className} release-highlighter--partial-delivery`}
        width={28}
        height={21}
        src={IMAGES.PartialTruckTwo}
        alt="Partial Delivery"
        style={{ cursor: 'pointer' }}
      />
    </OverlayTrigger>
  );
};

export default PartialDeliverSpan;
